import React from 'react';
import EmailSignup from './auth-methods/email-signup.component';
import styled from 'styled-components';
import { Tab, Tabs } from 'react-bootstrap';
import GoogleLogin from './auth-methods/google-login.component';
import { Envelope, Google, Phone } from 'react-bootstrap-icons';
import PhoneLogin from './auth-methods/phone-login.component';

const LoginContainerStyles = styled.div`
    #auth-methods-tab {
        width: 100%
    }
`;
export default function Signup() {
    return (
        <div className="auth-wrapper">
            <div className="auth-inner">
                <div className="auth-main">
                    <h3>Sign Up</h3>
                    <LoginContainerStyles>
                        <Tabs
                            defaultActiveKey="email"
                            id="auth-methods-tab"
                            className="mb-3"
                        >
                            <Tab eventKey="email" title={<Envelope />}>
                                <EmailSignup></EmailSignup>
                            </Tab>
                            <Tab eventKey="google" title={<Google />}>
                                <GoogleLogin></GoogleLogin>
                            </Tab>
                            <Tab eventKey="phone" title={<Phone />}>
                                <PhoneLogin></PhoneLogin>
                            </Tab>
                        </Tabs>
                    </LoginContainerStyles>
                </div>
                <div className='auth-secondary'>
                    <a href="/terms" className='text-right'>
                        Terms
                    </a>
                    <a className='text-left' href="/privacy-policy">Privacy</a>
                </div>
            </div>
        </div>
    )

}
